(() => {
  if (window.__NHIP_CUSTOM_MODERN_V5) return;
  window.__NHIP_CUSTOM_MODERN_V5 = true;

  const SEARCH_URL = 'https://hook.us2.make.com/5u4hyf1rb7jghatmwalgrhvbd0b6hy5w';
  const ACCEPT_URL = 'https://hook.us2.make.com/2mxybqctnxdeyqb5yoda9vax3odqu21d';

  const COVERAGE = window.NHIP_COVERAGE;
  if (!COVERAGE) return;

  let cartBusy = false;
  let searchBusy = false;

  const esc = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  }[char]));

  const parseDays = (label) => {
    const match = String(label || '').match(/\d+/);
    return match ? Number(match[0]) : NaN;
  };

  const normalizeTier = (tier) => String(tier || 'REGULAR').toUpperCase();

  const tierLabel = (tier) =>
    normalizeTier(tier) === 'PREMIUM' ? 'Premium' : 'Regular';

  const customerDataLabel = (option) => {
    const planType = String(option?.plan_type || '').toUpperCase();
    if (planType.includes('UNLIMITED')) {
      return String(option?.display_label || 'Unlimited');
    }
    const gb = Number(option?.data_gb);
    if (Number.isFinite(gb) && gb > 0 && gb < 1) {
      return `${Math.round(gb * 1024)}MB`;
    }
    return String(
      option?.display_label || (Number.isFinite(gb) ? `${gb}GB` : '')
    );
  };

  function isCustomTrigger(el) {
    if (!el) return false;
    if (el.matches('[data-nhip-custom-quote]')) return true;
    if (el.closest('[id$="__rich_text_33GHEx"]')) return true;
    if (el.closest('.nhip-product-custom-quote-cta')) return true;
    const text = String(el.textContent || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
    return text.includes('custom') && text.includes('quote');
  }

  function buttonMatch(target) {
    const el = target && target.closest ? target.closest('a,button') : null;
    return isCustomTrigger(el) ? el : null;
  }

  function setCustomButtonActive(el) {
    if (!el) return;
    el.removeAttribute('aria-disabled');
    el.removeAttribute('disabled');
    if ('disabled' in el) el.disabled = false;
    el.classList.remove('disabled');
    el.style.setProperty('cursor', 'pointer', 'important');
  }

  function ensureStyles() {
    if (document.getElementById('nhip-custom-modern-style')) return;

    const style = document.createElement('style');
    style.id = 'nhip-custom-modern-style';

    style.textContent = `
      #nhip-custom-modal{display:none;position:fixed;inset:0;z-index:999999;background:rgba(0,0,0,.55);padding:18px;overflow:auto;align-items:flex-start;justify-content:center}
      #nhip-custom-modal.nhip-open{display:flex}
      #nhip-custom-modal .nhip-panel{background:#fff;color:#111;width:min(760px,100%);margin:5vh auto 40px;padding:22px;border-radius:10px;box-shadow:0 24px 70px rgba(0,0,0,.3);font-family:inherit;max-height:90vh;overflow-y:auto;overscroll-behavior:contain;scrollbar-gutter:stable}
      #nhip-custom-modal .nhip-head{display:flex;justify-content:space-between;gap:18px;align-items:flex-start}
      #nhip-custom-modal h2{font-size:22px;margin:0 0 6px}
      #nhip-custom-modal p{margin:6px 0 12px}
      #nhip-custom-modal .nhip-close{border:0;background:transparent;font-size:28px;line-height:1;cursor:pointer;padding:0 4px}
      #nhip-custom-modal .nhip-field{margin:12px 0}
      #nhip-custom-modal label{display:block;font-weight:700;margin-bottom:5px}
      #nhip-custom-modal select,#nhip-custom-modal input{width:100%;box-sizing:border-box;padding:10px 11px;border:1px solid #bbb;border-radius:4px;background:#fff;color:#111;font:inherit}
      #nhip-custom-modal .nhip-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}
      #nhip-custom-modal .nhip-help{border:1px solid #d7d7d7;background:#f7f7f7;border-radius:5px;padding:10px 12px;font-size:13px;line-height:1.35;margin:12px 0}
      #nhip-custom-modal .nhip-actions{display:flex;gap:10px;flex-wrap:wrap;margin:14px 0}
      #nhip-custom-modal .nhip-btn{appearance:none;border:1px solid #111;background:#111;color:#fff;padding:10px 16px;font-weight:700;cursor:pointer;font:inherit}
      #nhip-custom-modal .nhip-btn.secondary{background:#fff;color:#111}
      #nhip-custom-modal .nhip-btn:disabled{opacity:.45;cursor:not-allowed}
      #nhip-custom-modal .nhip-result{border-top:1px solid #ddd;margin-top:16px;padding-top:16px}
      #nhip-custom-modal .nhip-card{border:1px solid #cfcfcf;border-radius:5px;padding:12px 14px;margin:9px 0;cursor:pointer;background:#fff;transition:border-color .15s,box-shadow .15s,background .15s}
      #nhip-custom-modal .nhip-card:hover{border-color:#777}
      #nhip-custom-modal .nhip-browse-option:focus-visible{outline:3px solid #2466a8;outline-offset:2px}
      #nhip-custom-modal .nhip-browse-option .nhip-card-title::before{content:"";display:inline-block;width:15px;height:15px;border:1px solid #555;border-radius:2px;margin-right:8px;vertical-align:middle;text-align:center;line-height:15px;font-size:13px}
      #nhip-custom-modal .nhip-browse-option[aria-checked="true"] .nhip-card-title::before{content:"✓";background:#111;color:#fff}
      #nhip-custom-modal .nhip-card[aria-checked="true"]{border-color:#111;box-shadow:0 0 0 1px #111;background:#fafafa}
      #nhip-custom-modal .nhip-card-title-row{display:flex;align-items:baseline;justify-content:space-between;gap:12px}
      #nhip-custom-modal .nhip-card-title{font-weight:800}
      #nhip-custom-modal .nhip-card-meta{
        font-size:14px;
        color:#333;
        margin-top:3px;
        font-weight:500;
      }
      #nhip-custom-modal .nhip-card-price{font-weight:800;font-size:16px;margin-top:0;white-space:nowrap}
      #nhip-custom-modal #nhip-options{box-sizing:border-box;max-height:min(540px,60dvh);overflow-y:auto;overscroll-behavior:contain;scrollbar-gutter:stable;border:1px solid #ddd;border-radius:7px;padding:6px}
      #nhip-custom-modal .nhip-status{font-weight:700;margin:12px 0}
      #nhip-custom-modal .nhip-selection-bar{position:sticky;top:0;z-index:6;background:#fff;border:1px solid #d7d7d7;border-radius:5px;box-shadow:0 8px 18px rgba(0,0,0,.08);padding:10px 12px;margin:0 0 12px;display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap}
      #nhip-custom-modal .nhip-selection-bar .nhip-status{margin:0}
      #nhip-custom-modal .nhip-selection-bar{position:sticky;top:0;z-index:6;background:#fff;border:1px solid #d7d7d7;border-radius:5px;box-shadow:0 8px 18px rgba(0,0,0,.08);padding:10px 12px;margin:0 0 12px;display:none;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap}
      #nhip-custom-modal .nhip-selection-bar.nhip-show{display:flex}
      #nhip-custom-modal .nhip-selection-bar .nhip-status{margin:0}
      #nhip-custom-modal .nhip-confirm-bar{position:sticky;top:0;z-index:7;background:#fff;border:1px solid #d7d7d7;border-radius:5px;box-shadow:0 8px 18px rgba(0,0,0,.10);padding:10px 12px;margin:0 0 12px;display:flex;gap:10px;align-items:center;flex-wrap:wrap;box-sizing:border-box}
      #nhip-custom-modal .nhip-note{font-size:12px;color:#666;margin-top:12px}
      #nhip-custom-modal .nhip-scroll-hint{font-size:12px;color:#555;margin:0 0 8px}
      #nhip-custom-modal .nhip-error{font-weight:700;color:#9a1b1b}

      @media(min-width:641px){
        #nhip-custom-modal{padding:10px}
        #nhip-custom-modal .nhip-panel{width:min(720px,100%);margin:1.5vh auto 16px;padding:14px 18px;max-height:96vh}
        #nhip-custom-modal h2{font-size:20px;margin:0 0 3px}
        #nhip-custom-modal p{margin:3px 0 7px}
        #nhip-custom-modal .nhip-field{margin:7px 0}
        #nhip-custom-modal label{margin-bottom:3px}
        #nhip-custom-modal select,#nhip-custom-modal input{padding:7px 9px}
        #nhip-custom-modal .nhip-grid{gap:8px}
        #nhip-custom-modal .nhip-help{padding:7px 9px;margin:7px 0;font-size:12px;line-height:1.25}
        #nhip-custom-modal .nhip-actions{margin:7px 0;gap:8px}
        #nhip-custom-modal .nhip-btn{padding:8px 13px}
        #nhip-custom-modal .nhip-result{margin-top:8px;padding-top:8px}
        #nhip-custom-modal .nhip-card{padding:8px 10px;margin:5px 0}
        #nhip-custom-modal .nhip-card-meta{font-size:12px}
        #nhip-custom-modal .nhip-card-price{font-size:15px}
        #nhip-custom-modal .nhip-status{margin:6px 0}
        #nhip-custom-modal .nhip-note{font-size:11px;line-height:1.25;margin-top:6px}
      }

      @media(max-width:640px){
        #nhip-custom-modal{padding:6px}
        #nhip-custom-modal .nhip-panel{margin:1vh auto 10px;padding:12px;max-height:94dvh}
        #nhip-custom-modal h2{font-size:19px;margin-bottom:4px}
        #nhip-custom-modal p{margin:4px 0 8px}
        #nhip-custom-modal .nhip-field{margin:8px 0}
        #nhip-custom-modal label{margin-bottom:3px;font-size:14px}
        #nhip-custom-modal select,#nhip-custom-modal input{padding:8px 9px}
        #nhip-custom-modal .nhip-grid{grid-template-columns:1fr 1fr;gap:8px}
        #nhip-custom-modal .nhip-grid label{font-size:13px;line-height:1.3;min-height:0}
        #nhip-custom-modal .nhip-note{font-size:11px;line-height:1.3}
        #nhip-custom-modal .nhip-help{display:none}
        #nhip-custom-modal .nhip-actions{margin:10px 0;gap:8px}
        #nhip-custom-modal .nhip-btn{padding:9px 12px;font-size:14px}
        #nhip-custom-modal .nhip-card{padding:10px 12px;margin:7px 0}
        #nhip-custom-modal .nhip-confirmed{margin-top:8px;padding-top:8px}
        #nhip-custom-modal .nhip-confirmed h3{margin:4px 0 8px}
        #nhip-custom-modal .nhip-confirmed p{margin:3px 0 6px}
        #nhip-custom-modal .nhip-confirmed .nhip-confirm-bar{padding:8px 10px;margin:0 0 6px;gap:8px}
      }

      #nhip-custom-modal .nhip-tier-help-mobile{display:none}
      #nhip-custom-modal .nhip-panel{max-height:calc(100dvh - 92px)}

      @media(max-width:640px){
        #nhip-custom-modal .nhip-tier-help-desktop{display:none}
        #nhip-custom-modal .nhip-tier-help-mobile{display:block;margin:2px 0 8px;font-size:12px}
        #nhip-custom-modal .nhip-tier-help-mobile summary{cursor:pointer;font-weight:700}
        #nhip-custom-modal .nhip-tier-help-mobile .nhip-note{margin:6px 0}
        #nhip-custom-modal .nhip-grid .nhip-field{display:flex;flex-direction:column}
        #nhip-custom-modal .nhip-grid label{min-height:2.6em;display:flex;align-items:flex-end}
      }

      #nhip-custom-modal .nhip-card-title,
      #nhip-custom-modal .nhip-card-meta,
      #nhip-custom-modal .nhip-card-network,
      #nhip-custom-modal .nhip-card-price,
      #nhip-custom-modal .nhip-card-title strong,
      #nhip-custom-modal .nhip-card-meta strong,
      #nhip-custom-modal .nhip-card-network strong,
      #nhip-custom-modal .nhip-card-price strong{
        font-family:inherit;
        font-size:14px;
        font-weight:700;
        color:#111;
        line-height:1.4;
      }

      #nhip-custom-modal .nhip-card-network{
        flex:1;
        min-width:140px;
        text-align:center;
        margin-top:3px;
        overflow-wrap:anywhere;
      }

      @media(max-width:640px){
        #nhip-custom-modal .nhip-card-title-row{
          flex-wrap:wrap;
          row-gap:3px;
        }
        #nhip-custom-modal .nhip-card-title{
          flex:1;
          min-width:0;
          overflow-wrap:anywhere;
        }
        #nhip-custom-modal .nhip-card-network{
          flex:0 0 100%;
          min-width:0;
          order:3;
          text-align:left;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function createModal() {
    if (document.getElementById('nhip-custom-modal')) {
      return document.getElementById('nhip-custom-modal');
    }

    ensureStyles();

    const modal = document.createElement('div');
    modal.id = 'nhip-custom-modal';

    const tierDescription = '<strong>Regular:</strong> Standard qualified connectivity on the plan’s standard supported network(s). <strong>Premium:</strong> An upgraded carrier option with a different supported network mix. In China, Premium uses China Telecom + China Unicom, while Regular uses China Mobile—giving Premium two supported carrier networks instead of one. Actual 4G/5G availability varies by location and device.';

    modal.innerHTML = `
      <div class="nhip-panel" role="dialog" aria-modal="true" aria-labelledby="nhip-custom-title">
        <div class="nhip-head">
          <div>
            <h2 id="nhip-custom-title">Get a Custom eSIM Quote</h2>
            <p>Tell us what you need. We’ll show all qualified NHIP options.</p>
          </div>
          <button type="button" class="nhip-close" id="nhip-custom-close" aria-label="Close">×</button>
        </div>

        <div class="nhip-field">
          <label for="nhip-q-destination">Destination</label>
          <select id="nhip-q-destination">
            <option value="">Choose destination</option>
            ${`<optgroup label="Regional & Global">${COVERAGE.regions.map((entry) => `<option value="${esc(entry.name)}" data-scope="${entry.type}" data-code="${esc(entry.code)}">${esc(entry.name)}</option>`).join('')}</optgroup><optgroup label="Countries & Territories">${COVERAGE.countries.slice().sort((a,b) => a.name.localeCompare(b.name)).map((entry) => `<option value="${esc(entry.name)}" data-scope="${entry.type}" data-code="${esc(entry.code)}">${esc(entry.name)}</option>`).join('')}</optgroup>`}
          </select>
        </div>

        <div class="nhip-field">
          <label for="nhip-q-tier">Service Tier</label>
          <select id="nhip-q-tier">
            <option value="REGULAR">Regular</option>
            <option value="PREMIUM">Premium</option>
            <option value="*" selected>* Regular &amp; Premium</option>
          </select>
          <div class="nhip-note nhip-tier-help-desktop" style="font-weight:700;color:#333;line-height:1.45">${tierDescription}</div>
          <details class="nhip-tier-help-mobile">
            <summary>About Regular and Premium</summary>
            <div class="nhip-note">${tierDescription}</div>
          </details>
        </div>

        <div class="nhip-grid">
          <div class="nhip-field">
            <label for="nhip-q-data">Data needed (MB, GB, U, or *)</label>
            <input id="nhip-q-data" type="text" inputmode="text" value="*" placeholder="Example: 100MB, 5GB, 100, U, Unlimited, or *">
          </div>
          <div class="nhip-field">
            <label for="nhip-q-validity">Validity (days)</label>
            <input id="nhip-q-validity" type="text" inputmode="numeric" value="" placeholder="1–365" required>
          </div>
        </div>

        <p class="nhip-note nhip-quantity-note">* Adjust the quantity of each eSIM plan in your cart.</p>

        <div class="nhip-help">
          <strong>Not sure which plan you need?</strong><br><br>
          • For fixed data, enter MB or GB, such as <strong>100MB</strong> or <strong>5GB</strong>.<br>
          • If you enter only a number, such as <strong>100</strong>, we’ll search both <strong>100MB</strong> and <strong>100GB</strong>.<br>
          • For unlimited data, enter <strong>U</strong>, <strong>UNL</strong>, <strong>Unlimited</strong>, or any entry beginning with <strong>“Un”</strong>.<br>
          • For unknown Data, enter <strong>*</strong>.<br>
          • For Validity, enter a whole number from <strong>1 to 365</strong>.<br><br>
          Fixed-data results are compared across our qualified connectivity pool.
        </div>

        <div class="nhip-actions">
          <button type="button" id="nhip-q-find" class="nhip-btn">GET MY eSIM QUOTE</button>
          <button type="button" id="nhip-q-cancel" class="nhip-btn secondary">NO THANKS</button>
        </div>

        <div id="nhip-custom-result" class="nhip-result" aria-live="polite"></div>
      </div>`;

    document.body.appendChild(modal);
    return modal;
  }

  const resultEl = () => document.getElementById('nhip-custom-result');

  function setResult(html) {
    const root = resultEl();
    if (root) root.innerHTML = html;
  }

  function openModal() {
    const modal = createModal();
    const panel = modal.querySelector('.nhip-panel');
    if (panel) panel.scrollTop = 0;
    modal.classList.add('nhip-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => document.getElementById('nhip-q-destination')?.focus(), 0);
  }

  function closeModal() {
    if (cartBusy) return;
    const modal = document.getElementById('nhip-custom-modal');
    if (!modal) return;
    const root = resultEl();
    const panel = modal.querySelector('.nhip-panel');
    if (root && panel) panel.appendChild(root);
    modal.classList.remove('nhip-open');
    document.body.style.overflow = '';
  }

  function expandProductDestinations() {
    if (!location.pathname.startsWith('/products/regional-global-esim')) return;

    const select = document.querySelector('select[name="options[Destination]"]');
    if (!select || select.dataset.nhipCoverageExpanded === 'true') return;

    const existing = new Set(
      Array.from(select.options, (option) => option.value.toLowerCase())
    );

    const missing = COVERAGE.entries.filter(
      (entry) => !existing.has(entry.name.toLowerCase())
    );

    if (!missing.length) return;

    const group = document.createElement('optgroup');
    group.label = 'More destinations — custom quote';

    missing.sort((a, b) => a.name.localeCompare(b.name)).forEach((entry) => {
      const option = document.createElement('option');
      option.value = entry.name;
      option.textContent = entry.name;
      option.dataset.nhipCustomDestination = 'true';
      group.appendChild(option);
    });

    select.appendChild(group);

    const note = document.createElement('p');
    note.className = 'nhip-product-destination-note';
    note.textContent = 'More destinations open a custom quote. Plan availability is checked before purchase.';
    note.style.cssText = 'font-size:12px;line-height:1.4;margin:5px 0 0;color:#555';
    select.closest('.product-form__input')?.appendChild(note);

    let readyDestination = select.value;

    select.addEventListener('change', (event) => {
      const option = select.selectedOptions[0];

      if (!option?.dataset.nhipCustomDestination) {
        readyDestination = select.value;
        return;
      }

      event.stopImmediatePropagation();
      event.stopPropagation();

      const destination = option.value;
      select.value = readyDestination;

      openModal();

      const quoteDestination = document.getElementById('nhip-q-destination');
      if (quoteDestination) quoteDestination.value = destination;
    }, true);

    select.dataset.nhipCoverageExpanded = 'true';
  }

  async function post(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(payload),
      cache: 'no-store'
    });

    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    return response.json();
  }
  function requestValues() {
    const destination = document.getElementById('nhip-q-destination')?.value || '';
    const tier = document.getElementById('nhip-q-tier')?.value || '*';
    const data = String(document.getElementById('nhip-q-data')?.value || '*').trim();
    const validity = String(document.getElementById('nhip-q-validity')?.value || '').trim();

    return {
      destination,
      country_code: COVERAGE.find(destination)?.code || '',
      scope: COVERAGE.find(destination)?.type || '',
      service_tier: tier,
      data_request: data || '*',
      validity_request: validity
    };
  }
    function isWildcard(value) {
    return String(value || '').trim() === '*';
  }

  function dataRequestUnit(value) {
    const normalized = String(value || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '');

    if (normalized.endsWith('MB')) return 'MB';
    if (normalized.endsWith('GB')) return 'GB';
    return 'BOTH';
  }

  function numericValue(value) {
    const number = Number(String(value || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(number) && number > 0 ? number : NaN;
  }

  function matchesDataRequest(option, value) {
    const requested = numericValue(value);
    const gb = Number(option?.data_gb);

    if (!Number.isFinite(requested) || !Number.isFinite(gb)) return false;

    const mbMatch = Math.round(gb * 1024) === requested;
    const gbMatch = gb === requested;
    const unit = dataRequestUnit(value);

    if (unit === 'MB') return mbMatch;
    if (unit === 'GB') return gbMatch;
    return mbMatch || gbMatch;
  }

  function validityValue(value) {
    const normalized = String(value || '').trim();

    if (!/^\d+$/.test(normalized)) return NaN;

    const number = Number(normalized);

    return Number.isSafeInteger(number) && number >= 1 && number <= 365
      ? number
      : NaN;
  }

  function isUnlimitedInput(value) {
    const normalized = String(value || '').trim().toLowerCase();

    return normalized === 'u' ||
      normalized === 'unl' ||
      normalized.startsWith('un');
  }

  function quotePlanType(option) {
    return String(option?.plan_type || '').toUpperCase().includes('UNLIMITED')
      ? 'UNLIMITED'
      : 'FIXED';
  }

  function unlimitedModelForOption(option) {
    const planType = String(option?.plan_type || '').toUpperCase();
    const label = String(option?.display_label || '').toLowerCase();

    if (planType === 'TRUE_UNLIMITED' || label.includes('true unlimited')) {
      return 'TRUE_UNLIMITED';
    }

    if (planType === 'UNLIMITED') {
      if (label.includes('512 kbps')) return 'DAILY_QUOTA_FUP_512KBPS';
      if (label.includes('500 kbps')) return 'DAILY_QUOTA_FUP_500KBPS';
      if (label.includes('1 mbps')) return 'DAILY_QUOTA_FUP_1MBPS';
      return 'DAILY_QUOTA';
    }

    return 'NONE';
  }

  function restoreResultPlacement() {
    const root = resultEl();
    const panel = document.querySelector('#nhip-custom-modal .nhip-panel');
    const actions = panel?.querySelector('.nhip-actions');

    if (root && actions) actions.insertAdjacentElement('afterend', root);
  }

  function sortOptions(options, requested) {
    const positiveNumber = value => {
      const number = Number(value);
      return Number.isFinite(number) && number > 0 ? number : Infinity;
    };
    const allowance = option => {
      if (optionIsUnlimited(option) && unlimitedModelForOption(option) === 'TRUE_UNLIMITED') return Infinity;
      const gb = positiveNumber(option.data_gb);
      return Number.isFinite(gb) ? Math.round(gb * 1024) : Infinity;
    };

    return [...options].sort((a, b) => {
      const aUnlimited = optionIsUnlimited(a);
      const bUnlimited = optionIsUnlimited(b);
      if (aUnlimited !== bUnlimited) return aUnlimited ? 1 : -1;

      const aDays = positiveNumber(parseDays(a.validity_label));
      const bDays = positiveNumber(parseDays(b.validity_label));
      if (aDays !== bDays) return aDays < bDays ? -1 : 1;

      const aData = allowance(a);
      const bData = allowance(b);
      if (aData !== bData) return aData < bData ? -1 : 1;

      const aPrice = positiveNumber(a.price_usd ?? a.quote_price_usd);
      const bPrice = positiveNumber(b.price_usd ?? b.quote_price_usd);
      if (aPrice !== bPrice) return aPrice < bPrice ? -1 : 1;

      return normalizeTier(a.service_tier)
        .localeCompare(normalizeTier(b.service_tier));
    });
  }

  function optionIsUnlimited(option) {
    return String(option?.plan_type || '').toUpperCase().includes('UNLIMITED');
  }

  function customerOfferKey(option) {
    const tier = normalizeTier(option?.service_tier);
    const days = parseDays(option?.validity_label);
    const planType = optionIsUnlimited(option) ? 'UNLIMITED' : 'FIXED';
    const gb = Number(option?.data_gb);

    const dataKey = planType === 'UNLIMITED'
      ? unlimitedModelForOption(option)
      : (Number.isFinite(gb) ? Math.round(gb * 1024) : 'NA');

    // Keep separate offers when their identity, networks, or price differ.
    const offerKey = String(option?.offer_key || '').trim();
    const coverageKey = String(option?.coverage_key || '').trim();
    const provider = String(option?.provider || '').trim().toUpperCase();
    const packageId = String(option?.provider_package_id || '').trim();
    const packageCode = String(option?.provider_package_code || '').trim();

    const networks = String(option?.network_summary || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

    const price = Number(option?.price_usd);

    const priceKey = Number.isFinite(price)
      ? price
      : String(option?.price_usd || '');

    return JSON.stringify([
      tier,
      days,
      planType,
      dataKey,
      offerKey,
      coverageKey,
      provider,
      packageId,
      packageCode,
      networks,
      priceKey
    ]);
  }

  function dedupeEquivalentOffers(options) {
    const uniqueByKey = new Map();

    options.forEach((option) => {
      const key = customerOfferKey(option);

      // Remove only identical copies; never pick one offer by cheapest price.
      if (!uniqueByKey.has(key)) uniqueByKey.set(key, option);
    });

    return Array.from(uniqueByKey.values());
  }

  function exactOptions(options, requested) {
    const dataWildcard = isWildcard(requested.data_request);
    const validityWildcard = isWildcard(requested.validity_request);
    const unlimitedRequested = isUnlimitedInput(requested.data_request);
    const dataNumber = numericValue(requested.data_request);
    const validityNumber = validityValue(requested.validity_request);

    return dedupeEquivalentOffers(options.filter((option) => {
      const optionDays = parseDays(option?.validity_label);

      if (!validityWildcard && optionDays !== validityNumber) return false;

      if (unlimitedRequested) {
        return optionIsUnlimited(option);
      }

      if (dataWildcard) {
        return true;
      }

      if (Number.isFinite(dataNumber)) {
        return (
          !optionIsUnlimited(option) &&
          matchesDataRequest(option, requested.data_request)
        );
      }

      return false;
    }));
  }

  function fixedPreferenceScore(option, requested) {
    const requestedData = numericValue(requested.data_request);
    const gb = Number(option?.data_gb);

    if (!Number.isFinite(gb)) return Number.POSITIVE_INFINITY;

    if (Number.isFinite(requestedData) && !isWildcard(requested.data_request)) {
      const unit = dataRequestUnit(requested.data_request);

      if (unit === 'MB') {
        return Math.abs(Math.round(gb * 1024) - requestedData);
      }

      if (unit === 'GB') {
        return Math.abs(gb - requestedData);
      }

      return Math.min(
        Math.abs(Math.round(gb * 1024) - requestedData),
        Math.abs(gb - requestedData)
      );
    }

    return gb;
  }

  function curateNearbyFallback(options, requested, limit = 7) {
    const requestedDays = validityValue(requested.validity_request);

    if (isWildcard(requested.validity_request)) {
      // Preserve every available duration; choose nearby fixed-data amounts
      // independently within each duration, rather than truncating to seven rows.
      const fixed = dedupeEquivalentOffers(options.filter(option => {
        const days = parseDays(option?.validity_label);
        return !optionIsUnlimited(option) && days >= 1 && days <= 365;
      }));
      const durations = [...new Set(fixed.map(option => parseDays(option.validity_label)))].sort((a,b) => a-b);
      return durations.flatMap(days => {
        const bucket = fixed.filter(option => parseDays(option.validity_label) === days);
        const amounts = [...new Set(bucket.map(option => Number(option.data_gb)))].filter(Number.isFinite)
          .sort((a,b) => fixedPreferenceScore({data_gb:a}, requested) - fixedPreferenceScore({data_gb:b}, requested) || a-b).slice(0,3);
        return bucket.filter(option => amounts.includes(Number(option.data_gb)));
      });
    }
    if (!Number.isFinite(requestedDays)) return [];

    const eligible = dedupeEquivalentOffers(
      options.filter((option) => {
        const days = parseDays(option?.validity_label);
        return Number.isFinite(days) && days >= requestedDays && days <= 365;
      })
    );

    if (!eligible.length) {
      return [];
    }

    const durations = Array.from(
      new Set(
        eligible
          .map((option) => parseDays(option?.validity_label))
          .filter(Number.isFinite)
      )
    )
      .sort((a, b) => a - b)
      .slice(0, 3);

    const selected = [];
    const selectedKeys = new Set();

    const add = (option) => {
      if (!option || selected.length >= limit) return;

      const key = customerOfferKey(option);

      if (selectedKeys.has(key)) return;

      selectedKeys.add(key);
      selected.push(option);
    };

    // First pass: one useful fixed plan and one Unlimited plan from each
    // of the three nearest longer-validity buckets.
    durations.forEach((days) => {
      const bucket = eligible.filter(
        (option) => parseDays(option?.validity_label) === days
      );

      const fixed = bucket
        .filter((option) => !optionIsUnlimited(option))
        .sort((a, b) => {
          const preference =
            fixedPreferenceScore(a, requested) - fixedPreferenceScore(b, requested);

          if (preference) return preference;

          const aPrice = Number(a?.price_usd);
          const bPrice = Number(b?.price_usd);

          if (
            Number.isFinite(aPrice) &&
            Number.isFinite(bPrice) &&
            aPrice !== bPrice
          ) {
            return aPrice - bPrice;
          }

          return Number(a?.data_gb) - Number(b?.data_gb);
        });

      const unlimited = bucket
        .filter(optionIsUnlimited)
        .sort((a, b) => {
          const aPrice = Number(a?.price_usd);
          const bPrice = Number(b?.price_usd);

          if (
            Number.isFinite(aPrice) &&
            Number.isFinite(bPrice) &&
            aPrice !== bPrice
          ) {
            return aPrice - bPrice;
          }

          return unlimitedModelForOption(a)
            .localeCompare(unlimitedModelForOption(b));
        });

      add(fixed[0]);
      add(unlimited[0]);
    });

    // Second pass: fill remaining slots with distinct useful offers from
    // the same nearest duration buckets, closest duration first.
    const remaining = eligible
      .filter((option) => durations.includes(parseDays(option?.validity_label)))
      .sort((a, b) => {
        const aDays = parseDays(a?.validity_label);
        const bDays = parseDays(b?.validity_label);

        if (aDays !== bDays) return aDays - bDays;

        const aUnlimited = optionIsUnlimited(a);
        const bUnlimited = optionIsUnlimited(b);

        if (aUnlimited !== bUnlimited) return aUnlimited ? 1 : -1;

        if (!aUnlimited && !bUnlimited) {
          const preference =
            fixedPreferenceScore(a, requested) - fixedPreferenceScore(b, requested);

          if (preference) return preference;
        }

        const aPrice = Number(a?.price_usd);
        const bPrice = Number(b?.price_usd);

        if (
          Number.isFinite(aPrice) &&
          Number.isFinite(bPrice) &&
          aPrice !== bPrice
        ) {
          return aPrice - bPrice;
        }

        return 0;
      });

    remaining.forEach(add);

    return selected.slice(0, limit).sort((a, b) => {
      const aDays = parseDays(a?.validity_label);
      const bDays = parseDays(b?.validity_label);

      if (aDays !== bDays) return aDays - bDays;

      const aUnlimited = optionIsUnlimited(a);
      const bUnlimited = optionIsUnlimited(b);

      if (aUnlimited !== bUnlimited) return aUnlimited ? 1 : -1;

      if (!aUnlimited && !bUnlimited) {
        const aData = Number(a?.data_gb);
        const bData = Number(b?.data_gb);

        if (
          Number.isFinite(aData) &&
          Number.isFinite(bData) &&
          aData !== bData
        ) {
          return aData - bData;
        }
      }

      const tierCompare = normalizeTier(a?.service_tier)
        .localeCompare(normalizeTier(b?.service_tier));

      if (tierCompare) return tierCompare;

      const aPrice = Number(a?.price_usd);
      const bPrice = Number(b?.price_usd);

      if (
        Number.isFinite(aPrice) &&
        Number.isFinite(bPrice) &&
        aPrice !== bPrice
      ) {
        return aPrice - bPrice;
      }

      return 0;
    });
  }

  function filteredOptions(options, requested) {
    const exact = exactOptions(options, requested);

    if (exact.length) {
      return {
        items: exact,
        exact: true,
        fallback: false
      };
    }

    return {
      items: [],
      exact: false,
      fallback: true
    };
  }

  function curateOptions(options) {
    const ranked = options.map((candidate, candidateIndex) => {
      const candidatePrice = Number(candidate.price_usd);
      const candidateData = Number(candidate.data_gb);
      const candidateDays = parseDays(candidate.validity_label);

      const dominated =
        Number.isFinite(candidatePrice) &&
        Number.isFinite(candidateData) &&
        Number.isFinite(candidateDays) &&
        options.some((other, otherIndex) => {
          if (otherIndex === candidateIndex) return false;

          if (
            normalizeTier(other.service_tier) !==
            normalizeTier(candidate.service_tier)
          ) {
            return false;
          }

          if (
            String(other.plan_type || 'FIXED').toUpperCase() !==
            String(candidate.plan_type || 'FIXED').toUpperCase()
          ) {
            return false;
          }

          const otherPrice = Number(other.price_usd);
          const otherData = Number(other.data_gb);
          const otherDays = parseDays(other.validity_label);

          if (
            !Number.isFinite(otherPrice) ||
            !Number.isFinite(otherData) ||
            !Number.isFinite(otherDays)
          ) {
            return false;
          }

          const noWorse =
            otherData >= candidateData &&
            otherDays >= candidateDays &&
            otherPrice <= candidatePrice;

          const strictlyBetter =
            otherData > candidateData ||
            otherDays > candidateDays ||
            otherPrice < candidatePrice;

          return noWorse && strictlyBetter;
        });

      return {candidate, dominated, candidateIndex};
    });

    return ranked.sort((a, b) => {
      const aPrice = Number(a.candidate.price_usd);
      const bPrice = Number(b.candidate.price_usd);
      const aValidPrice = Number.isFinite(aPrice) && aPrice > 0;
      const bValidPrice = Number.isFinite(bPrice) && bPrice > 0;

      if (aValidPrice && bValidPrice && aPrice !== bPrice) {
        return aPrice - bPrice;
      }

      if (aValidPrice !== bValidPrice) return aValidPrice ? -1 : 1;
      if (a.dominated !== b.dominated) return a.dominated ? 1 : -1;

      const aDays = parseDays(a.candidate.validity_label);
      const bDays = parseDays(b.candidate.validity_label);

      if (
        Number.isFinite(aDays) &&
        Number.isFinite(bDays) &&
        aDays !== bDays
      ) {
        return aDays - bDays;
      }

      if (Number.isFinite(aDays) !== Number.isFinite(bDays)) {
        return Number.isFinite(aDays) ? -1 : 1;
      }

      const aData = Number(a.candidate.data_gb);
      const bData = Number(b.candidate.data_gb);

      if (
        Number.isFinite(aData) &&
        Number.isFinite(bData) &&
        aData !== bData
      ) {
        return aData - bData;
      }

      if (Number.isFinite(aData) !== Number.isFinite(bData)) {
        return Number.isFinite(aData) ? -1 : 1;
      }

      const tierCompare = normalizeTier(a.candidate.service_tier)
        .localeCompare(normalizeTier(b.candidate.service_tier));

      if (tierCompare) return tierCompare;

      return a.candidateIndex - b.candidateIndex;
    }).map((entry) => entry.candidate);
  }

  function fitOptionsListToSeven() {
    const list = document.getElementById('nhip-options');
    if (!list) return;

    const cards = list.querySelectorAll('.nhip-browse-option');
    const previousScrollTop = list.scrollTop;

    list.scrollTop = 0;
    list.style.height = '';

    if (cards.length <= 7) {
      list.scrollTop = previousScrollTop;
      return;
    }

    // Measure the actual text-wrapped rows at this screen width so the eighth
    // row starts below the scroll box instead of appearing partly cut off.
    const seventhBottom = cards[6].getBoundingClientRect().bottom;
    const listTop = list.getBoundingClientRect().top;

    list.style.height = `${Math.ceil(seventhBottom - listTop + 3)}px`;
    list.scrollTop = previousScrollTop;
  }

  function applyPremiumGap(options) {
    return options.map((option) => {
      if (
        normalizeTier(option.service_tier) !== 'PREMIUM' ||
        String(option.plan_type).toUpperCase() !== 'FIXED'
      ) {
        return option;
      }

      const regular = options.find((candidate) =>
        normalizeTier(candidate.service_tier) === 'REGULAR' &&
        String(candidate.plan_type).toUpperCase() === 'FIXED' &&
        Number(candidate.data_gb) === Number(option.data_gb) &&
        parseDays(candidate.validity_label) === parseDays(option.validity_label)
      );

      const regularPrice = Number(regular?.price_usd);
      const premiumPrice = Number(option.price_usd);

      if (
        !regular ||
        !Number.isFinite(regularPrice) ||
        regularPrice <= 0 ||
        !Number.isFinite(premiumPrice)
      ) {
        return option;
      }

      const minimumPremium =
        Math.ceil((regularPrice * 1.2 - 1e-8) * 20) / 20;

      return {
        ...option,
        price_usd: Math.max(premiumPrice, minimumPremium),
        regular_reference_price_usd: regularPrice
      };
    });
  }
    function renderBrowse(data, requested, overrideOptions = null, isFallback = false) {
    const raw = Array.isArray(data.options) ? data.options : [];
    const match = filteredOptions(raw, requested);
    const matchedOptions = Array.isArray(overrideOptions) ? overrideOptions : match.items;
    const options = sortOptions(matchedOptions, requested);

    if (!options.length) {
      setResult(
        '<p class="nhip-error">There are currently no available plans for this destination and service tier.</p>'
      );
      return;
    }

    const requestedDays = validityValue(requested.validity_request);

    const crossType = isFallback === 'fixed-alternatives' || isFallback === 'unlimited-alternatives';
    const heading = crossType
      ? (isFallback === 'fixed-alternatives' ? 'No unlimited plans available — fixed-data alternatives' : 'No fixed-data plans match your request — unlimited alternatives')
      : isFallback === 'choices'
      ? 'Available eSIM options for your trip'
      : isFallback === 'available'
      ? 'Available plans for your destination'
      : isFallback
      ? (isWildcard(requested.validity_request)
          ? 'No exact data match — nearby data options across available validities'
          : `No exact data and validity match — alternatives valid for at least ${requestedDays} days`)
      : 'Available NHIP™ eSIM Options';

    const rows = options.map((option, index) => {
      const price = Number(option.price_usd);

      const priceHtml = Number.isFinite(price)
        ? `<div class="nhip-card-price">$${price.toFixed(2)}</div>`
        : '';

      const badge = String(option.plan_type || '')
        .toUpperCase()
        .includes('UNLIMITED')
        ? 'Unlimited'
        : 'Fixed Data';

      return `<div class="nhip-card nhip-browse-option" role="checkbox" tabindex="0" aria-checked="false" data-index="${index}">
        <div class="nhip-card-title-row"><div class="nhip-card-title">${esc(tierLabel(option.service_tier))} · ${esc(customerDataLabel(option))}</div><div class="nhip-card-network"><strong>Networks:</strong> ${esc(option.network_summary || 'Carrier not specified')}</div>${priceHtml}</div>
        <div class="nhip-card-meta">${esc(badge)} · ${esc(option.validity_label || '')}</div>
      </div>`;
    }).join('');

    setResult(`
      <h3 id="nhip-options-title">${esc(heading)}</h3>
      <p>${crossType
        ? `We found ${options.length} alternative plan${options.length === 1 ? '' : 's'}. Please review each plan’s data allowance and actual validity.${!isWildcard(requested.validity_request) && options.some(o => parseDays(o.validity_label) < requestedDays) ? ' Shorter plans do not cover your full requested stay.' : ''}`
        : isFallback === 'choices'
        ? 'Compare the available fixed-data and unlimited alternatives. Data amounts, daily high-speed allowances and validity vary; review each plan.'
        : isFallback === 'available'
        ? `These plans differ from your request. Available validity is up to ${Math.max(...options.map(o => parseDays(o.validity_label)))} days; shorter plans do not cover your full requested stay. Please review each plan’s data and validity.`
        : isFallback
        ? (isWildcard(requested.validity_request)
          ? `We found ${options.length} nearby data options across available durations from 1 to 365 days. Data amounts may be lower or higher than requested; review each plan.`
          : `We found ${options.length} qualified alternatives that meet or exceed your requested ${requestedDays} days. Data amounts may differ; review each plan.`)
        : `We found ${options.length} qualified option${options.length === 1 ? '' : 's'} matching your request.`}</p>
      ${options.length > 3 ? '<p class="nhip-scroll-hint">Scroll inside the box to see more plans.</p>' : ''}
      <div id="nhip-selection-bar" class="nhip-selection-bar nhip-show"><div id="nhip-selection-status" class="nhip-status">Select one or more plans.</div><button type="button" id="nhip-continue" class="nhip-btn" disabled>ADD SELECTED PLANS TO CART</button></div>
      <div id="nhip-options" role="group" aria-labelledby="nhip-options-title">${rows}</div>
      <div class="nhip-note">Select one or more plans below. Need more than one of a plan? Adjust its quantity in your cart.</div>
    `);

    const cards = Array.from(
      document.querySelectorAll('#nhip-options .nhip-browse-option')
    );

    const continueButton = document.getElementById('nhip-continue');
    const selectionStatus = document.getElementById('nhip-selection-status');
    const selected = new Map();

    const choose = (index) => {
      if (cartBusy || !options[index]) return;
      if (selected.has(index)) selected.delete(index);
      else selected.set(index, Object.freeze({...options[index]}));
      cards[index].setAttribute('aria-checked', selected.has(index) ? 'true' : 'false');

      if (selectionStatus) {
        const count = selected.size;
        const total = Array.from(selected.values()).reduce((sum, offer) => sum + Number(offer.price_usd), 0);
        selectionStatus.textContent = count
          ? `${count} plan${count === 1 ? '' : 's'} selected · $${total.toFixed(2)} before discounts`
          : 'Select one or more plans.';
      }
      if (continueButton) continueButton.disabled = selected.size === 0;
    };

    cards.forEach((card, index) => {
      card.addEventListener('click', () => choose(index));

      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose(index);
        }
      });
    });

    continueButton?.addEventListener('click', async () => {
      if (!selected.size || cartBusy) return;
      await addSelectedToCart(Array.from(selected.values()), requested);
    });

    requestAnimationFrame(fitOptionsListToSeven);
  }

  function cartPageUrl() {
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(window.routes?.cart_url || `${root}cart`, location.origin);
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search;
  }

  async function prepareSelectedOffer(offer, context) {
    const provider = String(offer.provider || '').trim().toUpperCase();
    const packageId = String(offer.provider_package_id || '').trim();
    const packageCode = String(offer.provider_package_code || '').trim();
    const offerKey = String(offer.offer_key || offer.coverage_key || '').trim();
    const price = Number(offer.price_usd);
    const dataGb = Number(offer.data_gb);
    const days = parseDays(offer.validity_label);
    if (!provider || !packageId || !packageCode || !offerKey ||
        !Number.isFinite(price) || price <= 0 ||
        !Number.isFinite(dataGb) || dataGb < 0 || !Number.isSafeInteger(days) || days < 1) {
      throw new Error('This selected offer is incomplete. Please search again; nothing was added to your cart.');
    }

    const chosen = {
      destination: context.destination,
      country_code: context.country_code,
      data_gb: dataGb,
      duration_days: days,
      plan_type: quotePlanType(offer),
      unlimited_model: unlimitedModelForOption(offer),
      service_tier: normalizeTier(offer.service_tier)
    };
    const quote = await post(SEARCH_URL, {
      ...chosen,
      data_request: String(dataGb),
      validity_request: String(days),
      coverage_key: offerKey,
      provider,
      provider_package_id: packageId,
      provider_package_code: packageCode,
      selected_price_usd: price,
      regular_reference_price_usd: Number(offer.regular_reference_price_usd) || 0,
      discovery_mode: false,
      internal_mode: false,
      customer_email: ''
    });

    // The existing backend signs the selected package. Do not accept a
    // same-size plan from another package or a different displayed price.
    const identity = String(quote.quote_token || '').split('|');
    if (quote.quote_available !== true || identity.length !== 5 ||
        identity[0] !== 'CUSTOM5' || identity[1] !== provider ||
        identity[2] !== packageId || identity[3] !== packageCode ||
        !quote.quote_signature || !quote.quote_issued_at ||
        !Number.isFinite(Number(quote.quote_price_usd)) ||
        Math.round(Number(quote.quote_price_usd) * 100) !== Math.round(price * 100)) {
      throw new Error('This exact offer could not be confirmed at its displayed price. Nothing was added to your cart. Please search again.');
    }

    const acceptancePayload = {
      ...chosen,
      price: Number(quote.quote_price_usd),
      token: quote.quote_token,
      sig: quote.quote_signature,
      issued_at: quote.quote_issued_at,
      valid_minutes: quote.quote_valid_minutes
    };
    let accepted;
    try {
      accepted = await post(ACCEPT_URL, acceptancePayload);
    } catch (firstError) {
      // Retain the existing one-time acceptance retry for a slow new-variant
      // response. The same signed offer is reused; cart/add is NOT retried.
      await new Promise((resolve) => setTimeout(resolve, 2500));
      accepted = await post(ACCEPT_URL, acceptancePayload);
    }
    const variantId = String(accepted.variant_id || '');
    if (accepted.accepted !== true || !/^\d+$/.test(variantId)) {
      throw new Error(accepted.reason || 'This eSIM could not be added right now. Nothing was substituted. Please search again.');
    }

    const properties = {
      _nhip_custom_quote: 'true',
      _nhip_provider: provider,
      _nhip_package_id: packageId,
      _nhip_package_code: packageCode,
      _nhip_offer_key: offerKey,
      _nhip_quoted_price_usd: price.toFixed(2)
    };
    if (offer.network_summary) properties.Networks = String(offer.network_summary);
    return {id: variantId, quantity: 1, properties, expectedPrice: Math.round(price * 100)};
  }

  async function addSelectedToCart(selected, requested) {
    if (cartBusy || !selected.length) return;
    cartBusy = true;
    const offers = selected.map((offer) => Object.freeze({...offer}));
    const context = Object.freeze({...requested});
    const controls = Array.from(document.querySelectorAll(
      '#nhip-custom-modal input, #nhip-custom-modal select, #nhip-custom-modal button'
    ));
    const disabledBefore = controls.map((control) => control.disabled);
    controls.forEach((control) => { control.disabled = true; });

    let cartRequestSent = false;
    try {
      const prepared = [];
      for (const offer of offers) {
        setResult(`<p role="status"><strong>Preparing plan ${prepared.length + 1} of ${offers.length}…</strong><br>Please keep this window open. You can adjust quantities in your cart.</p>`);
        prepared.push(await prepareSelectedOffer(offer, context));
      }
      const root = window.Shopify?.routes?.root || '/';
      const addPath = window.routes?.cart_add_url || `${root}cart/add`;
      const addUrl = addPath.endsWith('.js') ? addPath : `${addPath}.js`;
      cartRequestSent = true;
      const added = await post(addUrl, {
        items: prepared.map(({id, quantity, properties}) => ({id, quantity, properties}))
      });
      const items = Array.isArray(added.items) ? added.items : [added];
      const currency = window.Shopify?.currency?.active || 'USD';
      for (const plan of prepared) {
        const item = items.find((entry) =>
          String(entry.variant_id || entry.id) === plan.id &&
          Object.entries(plan.properties).every(([key, value]) => entry.properties?.[key] === value)
        );
        const unitPrice = Number(item?.original_price ?? item?.price);
        if (!item || (currency === 'USD' &&
            (!Number.isFinite(unitPrice) || unitPrice !== plan.expectedPrice))) {
          throw new Error('The cart response needs to be reviewed.');
        }
      }
      window.location.assign(cartPageUrl());
    } catch (error) {
      console.error('NHIP selected-offer cart error', error);
      const message = cartRequestSent
        ? 'We could not confirm the cart update. Please view your cart before adding these plans again. No payment has been taken.'
        : (error.message || 'We could not prepare these exact plans. Please search again.');
      setResult(`<p class="nhip-error" role="alert">${esc(message)}</p>${cartRequestSent
        ? `<a class="nhip-btn" style="display:inline-block;text-decoration:none" href="${esc(cartPageUrl())}">VIEW CART</a>`
        : ''}`);
    } finally {
      cartBusy = false;
      controls.forEach((control, index) => { control.disabled = disabledBefore[index]; });
    }
  }

  function buildDiscoveryPayload(requested, planType) {
    const dataNumber = numericValue(requested.data_request);
    const validityNumber = validityValue(requested.validity_request);

    return {
      destination: requested.destination,
      country_code: requested.country_code,
      scope: requested.scope,
      data_request: planType === 'UNLIMITED' ? 'U' : '*',
      validity_request: requested.validity_request,
      data_gb: '*',
      duration_days: isWildcard(requested.validity_request) ? 0 : validityNumber,
      plan_type: planType,
      unlimited_model: planType === 'UNLIMITED' ? '*' : 'NONE',
      service_tier: requested.service_tier,
      discovery_mode: true,
      internal_mode: false,
      customer_email: ''
    };
  }

  // Last resort only: keep destination, scope and tier; broaden duration and data.
  async function availableDestinationOptions(requested, search) {
    const broad = {...requested, data_request:'*', validity_request:'*'};
    const families = isUnlimitedInput(requested.data_request) ? ['UNLIMITED'] : ['FIXED','UNLIMITED'];
    const responses = await Promise.all(families.map(type => search(buildDiscoveryPayload(broad,type))));
    return dedupeEquivalentOffers(responses.flatMap(r => Array.isArray(r.options)?r.options:[])
      .filter(o => {const days=parseDays(o.validity_label);return days>=1 && days<=365;}))
      .sort((a,b) => parseDays(b.validity_label)-parseDays(a.validity_label) || fixedPreferenceScore(a,requested)-fixedPreferenceScore(b,requested) || Number(a.price_usd)-Number(b.price_usd));
  }

  function matchQuoteOptions(raw, requested) {
    const unlimitedOnly = isUnlimitedInput(requested.data_request);
    const pool = raw.filter(o => (!unlimitedOnly || optionIsUnlimited(o)) && parseDays(o.validity_label)>=1 && parseDays(o.validity_label)<=365);
    const exact = exactOptions(pool, requested);
    const wildcard = isWildcard(requested.data_request);
    if (unlimitedOnly || wildcard) {
      if (exact.length) return {options:exact,mode:false};
      const nearby = curateNearbyFallback(pool,requested,7);
      // Do not let the nearby-plan display cap hide unlimited choices.
      const days = new Set(nearby.map(o=>parseDays(o.validity_label)));
      return {options:dedupeEquivalentOffers([...nearby,...pool.filter(o=>optionIsUnlimited(o)&&days.has(parseDays(o.validity_label)))]),mode:true};
    }
    const fixed = pool.filter(o=>!optionIsUnlimited(o));
    const exactFixed = exactOptions(fixed,requested);
    const fixedChoices = exactFixed.length && !isWildcard(requested.validity_request) ? exactFixed : curateNearbyFallback(fixed,requested,7);
    const unlimited = pool.filter(optionIsUnlimited);
    const exactUnlimited = exactOptions(unlimited,{...requested,data_request:'U'});
    const unlimitedChoices = exactUnlimited.length ? exactUnlimited : unlimited.filter(o=>isWildcard(requested.validity_request)||parseDays(o.validity_label)>=validityValue(requested.validity_request));
    return {options:dedupeEquivalentOffers([...fixedChoices,...unlimitedChoices]),mode:unlimitedChoices.length?(fixedChoices.length?'choices':'unlimited-alternatives'):!exactFixed.length};
  }

  async function discoverQuoteOptions(requested, search) {
    const families = isUnlimitedInput(requested.data_request)?['UNLIMITED']:['FIXED','UNLIMITED'];
    const responses = await Promise.all(families.map(type=>search(buildDiscoveryPayload(requested,type))));
    const raw = responses.flatMap(r=>Array.isArray(r.options)?r.options:[]);
    const result = matchQuoteOptions(raw,requested);
    if (result.options.length) return result;
    const available = await availableDestinationOptions(requested,search);
    if (available.length) {
      const onlyUnlimited = !isUnlimitedInput(requested.data_request) && !isWildcard(requested.data_request) && available.every(optionIsUnlimited);
      return {options:available,mode:onlyUnlimited?'unlimited-alternatives':'available'};
    }
    if (isUnlimitedInput(requested.data_request)) {
      // Only cross families after confirming no unlimited plans at any validity.
      const fixedRequest = {...requested,data_request:'*'};
      const fixedResponse = await search(buildDiscoveryPayload({...fixedRequest,validity_request:'*'},'FIXED'));
      const fixed = (Array.isArray(fixedResponse.options)?fixedResponse.options:[]).filter(o=>!optionIsUnlimited(o)&&parseDays(o.validity_label)>=1&&parseDays(o.validity_label)<=365);
      const matched = matchQuoteOptions(fixed,fixedRequest);
      return {options:matched.options.length?matched.options:sortOptions(fixed,fixedRequest),mode:'fixed-alternatives'};
    }
    return {options:[],mode:'available'};
  }

  async function runSearch() {
    if (cartBusy || searchBusy) return;
    restoreResultPlacement();

    const requested = requestValues();

    if (!requested.destination || !requested.country_code) {
      setResult('<p class="nhip-note">Please choose a destination.</p>');
      return;
    }

    const dataNumber = numericValue(requested.data_request);
    const validityNumber = validityValue(requested.validity_request);
    const unlimitedRequested = isUnlimitedInput(requested.data_request);

    if (
      !isWildcard(requested.data_request) &&
      !unlimitedRequested &&
      !Number.isFinite(dataNumber)
    ) {
      setResult(
        '<p class="nhip-note">Enter fixed data such as 5 or 10, Unlimited as U / UNL / Unlimited, or * to see all qualified options.</p>'
      );
      return;
    }

    if (!isWildcard(requested.validity_request) && !Number.isFinite(validityNumber)) {
      setResult(
        '<p class="nhip-note">Enter a whole number from 1 to 365 for validity.</p>'
      );
      return;
    }

    setResult(
      '<p><strong>Searching available NHIP connectivity options…</strong></p>'
    );

    const primaryPlanType = unlimitedRequested ? 'UNLIMITED' : 'FIXED';
    searchBusy = true;
    const findButton = document.getElementById('nhip-q-find');
    if (findButton) findButton.disabled = true;

    try {
      const result = await discoverQuoteOptions(requested,payload=>post(SEARCH_URL,payload));
      if (result.options.length) {
        renderBrowse({options:result.options},requested,result.options,result.mode);
        return;
      }
      setResult('<p class="nhip-error">There are currently no available plans for this destination and service tier. Please check another destination or service tier.</p>');
    } catch (error) {
      console.error('NHIP CUSTOM search error', error);

      setResult(
        '<p class="nhip-note">We could not complete the search right now. Please try again.</p>'
      );
    } finally {
      searchBusy = false;
      if (findButton) findButton.disabled = false;
    }
  }

  function enableCustomButtons() {
    document.querySelectorAll('a,button').forEach((el) => {
      if (!isCustomTrigger(el)) return;
      setCustomButtonActive(el);
    });
  }

  document.addEventListener('pointerover', (event) => {
    const button = buttonMatch(event.target);

    if (!button) return;

    setCustomButtonActive(button);
  }, true);

  function init() {
    enableCustomButtons();

    const modal = createModal();

    if (location.hash === '#nhip-custom-quote') openModal();

    expandProductDestinations();

    const productInfo = document.querySelector(
      'select[name="options[Destination]"]'
    )?.closest('.product__info-container');

    if (productInfo) {
      new MutationObserver(expandProductDestinations).observe(
        productInfo,
        {childList:true, subtree:true}
      );
    }

    window.addEventListener(
      'resize',
      () => requestAnimationFrame(fitOptionsListToSeven)
    );

    document.addEventListener('click', (event) => {
      const button = buttonMatch(event.target);

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.matches('[data-nhip-custom-quote]') && !cartBusy && !searchBusy) {
        setResult('');
        restoreResultPlacement();
        document.getElementById('nhip-q-destination').value = '';
        document.getElementById('nhip-q-data').value = '*';
        document.getElementById('nhip-q-validity').value = '';
      }
      openModal();
    });

    // A text-selection drag can end on the backdrop and synthesize a click there.
    let backdropPointerDown = false;
    modal.addEventListener('pointerdown', (event) => {
      backdropPointerDown = event.target === modal;
    });
    modal.addEventListener('pointercancel', () => {
      backdropPointerDown = false;
    });
    modal.addEventListener('click', (event) => {
      const dismiss = backdropPointerDown && event.target === modal;
      backdropPointerDown = false;
      if (dismiss) closeModal();
    });

    document.getElementById('nhip-custom-close')?.addEventListener(
      'click',
      closeModal
    );

    document.getElementById('nhip-q-cancel')?.addEventListener(
      'click',
      closeModal
    );

    document.getElementById('nhip-q-find')?.addEventListener(
      'click',
      runSearch
    );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('nhip-open')) {
        closeModal();
      }
    });
  }

  // Shared by the business roster and the product/landing quotation modal.
  window.NHIP_QUOTE_MATCHING = {exactOptions, curateNearbyFallback, sortOptions, buildDiscoveryPayload, availableDestinationOptions, matchQuoteOptions, discoverQuoteOptions};

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }
})();

